import type { IEntityParamItem } from '@/types/entityParams';
import type { ISiteParamListRowApi, ISiteParamMutationRow } from '@/types/siteParams';
import { AbstractModel } from './abstractModel';

export class SiteParamItem extends AbstractModel implements IEntityParamItem {
    id: number = 0;
    param: string = '';
    siteId: number = 0;
    value: string = '';

    constructor(data?: ISiteParamListRowApi) {
        super();

        if (data) {
            this.id = data.id;
            this.siteId = data.site_id;
            this.param = data.param;
            this.value = data.value ?? '';
        }
    }

    toCreateApiData(): ISiteParamMutationRow {
        return {
            site_id: this.siteId,
            param: this.param.trim(),
            value: this.formatValue(this.value),
        };
    }

    toUpdateApiData(fields: Array<'param' | 'value'>): ISiteParamMutationRow {
        const row: ISiteParamMutationRow = { id: this.id };

        if (fields.includes('param')) {
            row.param = this.param.trim();
        }

        if (fields.includes('value')) {
            row.value = this.formatValue(this.value);
        }

        return row;
    }

    private formatValue(value: string): string | null {
        const trimmed = value.trim();
        return trimmed === '' ? null : trimmed;
    }
}
